import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Tasks } from "./types.js";
addProp(_User, "tasks", Tasks, "planner/tasks");
//# sourceMappingURL=users.js.map